function randomId() {
  const r = Math.random().toString(36).substring(7);

  return `${Date.now()}${r}`;
}

export default randomId;
